export default function GridIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M21 14H14V21H21V14Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 14H3V21H10V14Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 3H14V10H21V3Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M10 3H3V10H10V3Z" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}
